import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGitlfsComponent } from './simple-icons-gitlfs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGitlfsComponent ],
    exports:      [ SimpleIconsGitlfsComponent ],
    bootstrap:    []
})
export class SimpleIconsGitlfsModule {}
